/* eslint-disable @typescript-eslint/no-explicit-any */
import { getTokenFromFE } from "../token";
import { feApi } from "@/app/api/utils/api";
import { ApiResponse } from "@/types";
import { Lang } from "@/i18n/settings";

export async function getFAQs(lang: Lang, subject: string) {
  try {
    const token = await getTokenFromFE();
    const queryParams = new URLSearchParams();
    if (subject) queryParams.append("subject", subject);

    const res = await feApi
      .auth(`Bearer ${token}`)
      .options({ next: { revalidate: 60 } })
      .url("/v1")
      .get(`/${lang}/faqs?${queryParams.toString()}`);

    return res as ApiResponse<any>;
  } catch (error) {
    console.error(error);

    return null;
  }
}
